// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".dbfb369dec3d969a9449b7d94b1e9c05ae30bc80.chunk.bundle.js";
};